import Swiper from "swiper/swiper-bundle";
import AOS from "aos";

export default {
  init() {    

    AOS.init();

    let button = document.querySelector(".mouse-tracking");
    if (button) {
      button.addEventListener("mousemove", (e) => {
        let rect = e.target.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;
        button.style.setProperty("--x", x + "px");
        button.style.setProperty("--y", y + "px");
      });
    }

    var Hero = new Swiper(".hero-swiper", {
      effect: 'fade',
      loop: true,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: ".hero__pagination",
        clickable: true,
      },
    });

    const scrollBtn = document.querySelector(".top");
    const btnVisibility = () => {
      if (window.scrollY > 300) {
          scrollBtn.style.visibility = "visible";
      } else {
          scrollBtn.style.visibility = "hidden";
      }
    };
    document.addEventListener("scroll", () => {
      btnVisibility();
    });
    scrollBtn.addEventListener("click", () => {
      window.scrollTo({
          top: 0,
          behavior: "smooth"
      });
    });

    (function (d) { var s = d.createElement("script"); s.setAttribute("data-account", "dl1DtlpVir"); s.setAttribute("src", "https://cdn.userway.org/widget.js"); (d.body || d.head).appendChild(s); })(document)

    // var searchQuery = document.querySelectorAll(".searchQuery")
    // var typingTimer;               
    // var typeInterval = 500;  
    // var searchInput = document.getElementById('search');

    // function searchFunction(){
      
    //   let input_search = document.getElementById("search").value;

    //   for (var i = 0; i < searchQuery.length; i++) {      
    //     if (searchQuery[i].textContent.toLowerCase()
    //     .includes(input_search.toLowerCase())) {
    //       searchQuery[i].classList.remove("d-none");
    //     } else {
    //       searchQuery[i].classList.add("d-none");
    //     }
    //   }
    // }

    // searchInput.addEventListener('keyup', () => {
    //     clearTimeout(typingTimer);
    //     typingTimer = setTimeout(searchFunction, typeInterval);
    // });
    
    const scrollProgress = document.getElementById('scroll-progress');
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;

    window.addEventListener('scroll', () => {
      const scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      scrollProgress.style.width = `${(scrollTop / height) * 100}%`;
    });

  },
  finalize() {},
};
